import { Routes, Route } from 'react-router-dom';
import MainLP from './components/MainLP';
import LP1 from './components/LP1';
import LP2 from './components/LP2';
import Checkout from './components/Checkout';

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainLP />} />
      <Route path="/wntm-jt01" element={<LP1 />} />
      <Route path="/wntm-jt02" element={<LP2 />} />
      <Route path="/checkout" element={<Checkout />} />
    </Routes>
  );
}

export default App;